import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/red-phone-icon.png'
import _imports_1 from '@/assets/img/qr-1.png'
import _imports_2 from '@/assets/img/qr-2.png'


const _hoisted_1 = { class: "consult-box" }
const _hoisted_2 = { class: "QR-code" }
const _hoisted_3 = { class: "btn" }

import { MessageOutlined } from '@ant-design/icons-vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'consult',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_popover = _resolveComponent("a-popover")!

  return (_openBlock(), _createBlock(_component_a_popover, {
    placement: "right",
    trigger: "click"
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "phone-box" }, [
          _createElementVNode("img", { src: _imports_0 }),
          _createElementVNode("div", { class: "phone" }, [
            _createElementVNode("p", null, "联系电话："),
            _createElementVNode("p", null, "400-811-9585")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_a_space, { size: 10 }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createElementVNode("div", { class: "QR-code-item" }, [
                _createElementVNode("img", { src: _imports_1 }),
                _createTextVNode(" 合作微信 ")
              ], -1),
              _createElementVNode("div", { class: "QR-code-item" }, [
                _createElementVNode("img", { src: _imports_2 }),
                _createTextVNode(" 客服微信 ")
              ], -1)
            ])),
            _: 1
          })
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(MessageOutlined), { style: {"margin-right":"10px"} }),
        _cache[2] || (_cache[2] = _createTextVNode("立即咨询 "))
      ])
    ]),
    _: 1
  }))
}
}

})